const _excluded = ["field", "form", "meta"],
  _excluded2 = ["errorMessage"],
  _excluded3 = ["name", "label", "defaultValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { mapFieldToMaskedTextField } from '../MaskedTextfield';
import { MaskedTextField } from 'office-ui-fabric-react';
import { Field } from 'formik';
import { timestampMaskFormat } from '../../Timestamp/timestampMaskFormat';
import { jsx as _jsx } from "react/jsx-runtime";
function FormikTimestampWrapper(_ref) {
  let {
      field,
      form,
      meta
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const _mapFieldToMaskedText = mapFieldToMaskedTextField({
      field,
      form,
      meta
    }),
    {
      errorMessage
    } = _mapFieldToMaskedText,
    fieldProps = _objectWithoutProperties(_mapFieldToMaskedText, _excluded2);
  return /*#__PURE__*/_jsx(MaskedTextField, _objectSpread(_objectSpread({
    errorMessage: errorMessage,
    mask: "99:59:59",
    maskFormat: timestampMaskFormat,
    maskChar: "0"
  }, props), fieldProps));
}
export const FormikTimestamp = _ref2 => {
  let {
      name,
      label,
      defaultValue
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/_jsx(Field, _objectSpread({
    label: label,
    name: name,
    defaultValue: defaultValue,
    component: FormikTimestampWrapper
  }, props));
};